import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

import { ValidCharactersSettings, CharactersValidation } from './valid-characters';
import { ZxcvbnLoad } from '../../zxcvbn-load';

/* Assess password strength via zxcvbn library  */
export function StrongPasswordValidator(
  level: string = '2',
  user_inputs: string[] = [],
  validCharacters: ValidCharactersSettings,
  zxcvbn,
): ValidatorFn {
  const l: number = parseInt(level);
  const requiredLevel: number = isNaN(l) ? 2 : Math.min(Math.max(0, l), 4);
  var passValidation = new CharactersValidation();

  return (control: AbstractControl): { [key: string]: any } => {
    var resultValidation = passValidation.isValid(validCharacters, control.value);

    const { score, feedback } = zxcvbn(control.value || '', user_inputs);

    const strong: boolean = score >= requiredLevel && resultValidation.isValid;

    return !strong
      ? {
          strongPassword: {
            valid: false,
            feedback,
            score,
            resultValidation,
          },
        }
      : null;
  };
}

@Directive({
  selector: '[strongPassword]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: StrongPasswordValidatorDirective, multi: true },
  ],
})
export class StrongPasswordValidatorDirective implements Validator, OnChanges {
  @Input() strongPassword: string;
  @Input('user_inputs') dictionary: string[];
  @Input('validCharactersSettings') validCharacters: ValidCharactersSettings;

  private valFn = Validators.nullValidator;
  private default_dictionary: string[] = [];
  private control: AbstractControl;
  private zxcvbn;

  ngOnInit() {
    ZxcvbnLoad.asyncLoad().then((zxcvbn) => {
      this.zxcvbn = zxcvbn;
      this.valFn = StrongPasswordValidator(
        this.strongPassword,
        [...this.default_dictionary, ...this.dictionary],
        this.validCharacters,
        this.zxcvbn,
      );

      if (this.control) this.control.updateValueAndValidity();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['strongPassword'];
    if (change && this.zxcvbn) {
      this.valFn = StrongPasswordValidator(
        change.currentValue,
        [...this.default_dictionary, ...this.dictionary],
        this.validCharacters,
        this.zxcvbn,
      );
    } else {
      this.valFn = Validators.nullValidator;
    }
  }

  validate(control: AbstractControl): { [key: string]: any } {
    this.control = control;
    return this.valFn(control);
  }
}
